import { combineReducers } from 'redux';

import app from './app/reducer';
import auth from './auth/reducer';
import user from './user/reducer';
import products from './products/reducer';
import promotions from './promotions/reducer';
import orders from './orders/reducer';
import router from './router/reducer';
import notifications from './notifications/reducer';

const rootReducer = combineReducers({
  app,
  auth,
  user,
  products,
  promotions,
  orders,
  router,
  notifications,
});

export default rootReducer;
